<template>
  <ContainerScrolling class="SubmissionInformation">
    <LayoutFill :no-gutters="!bannerGutter" :no-padding="!bannerGutter">
      <MainBanner :title="pageTitle" :solid-header="solidHeader" />
    </LayoutFill>
    <LayoutGutters>
      <SubNavigationTabs
        id="submissionInformation"
        v-slot="{ activeTab }"
        :page-title="pageTitle"
        :page-mapping="pageMapping"
        :centered-tabs="centeredTabs"
      >
        <v-tab
          v-for="(tab, index) in tabs"
          :id="`tab-${index}`"
          :key="index"
          :aria-controls="`panel-${index}`"
          :tabindex="activeTab !== index ? -1 : 0"
        >
          {{ tab.tabName }}
          <span v-if="tab.appendS" class="lowercase">s</span>
        </v-tab>

        <v-tab-item v-for="(tab, index) in tabs" :key="index">
          <v-card flat>
            <div
              :id="`panel-${index}`"
              role="tabpanel"
              :aria-labelledby="`tab-${index}`"
              :hidden="activeTab !== index"
            >
              <LegalTerms :term="tab.term" />
            </div>
          </v-card>
        </v-tab-item>
      </SubNavigationTabs>
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";
import LayoutFill from "~/components/layout/LayoutFill";
import SubNavigationTabs from "~/components/navigation/SubNavigationTabs";

import MainBanner from "~/components/banner/MainBanner";
import LegalTerms from "~/components/page/components/terms/LegalTerms";

import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";

export default {
  name: "SubmissionInformation",
  components: {
    LegalTerms,
    ContainerScrolling,
    LayoutGutters,
    LayoutFill,
    MainBanner,
    SubNavigationTabs,
  },
  middleware: ["ensureUserLoaded"],
  data() {
    return {
      pageTitle: "How to Submit",
    };
  },
  head() {
    const { siteName, domain } = this;

    const title = getPageTitle(siteName);
    const pageTitle = "How To Submit | " + title;

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `For help and guidance on submitting early research to ${siteName}, in ${domain}.`,
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      siteName: (state) => getSiteName(state.theme),
      domain: (state) => state.theme.domain,
      layout: (state) => state.theme.layout,
      terms: (state) => state.theme.terms,
    }),
    tabs() {
      const tabs = [
        { tabName: "Author FAQ", term: "AUTHOR-FAQ", appendS: true },
        { tabName: "Submission Guide", term: "SUBMISSION-GUIDE" },
      ];

      if ("DIRECT-JOURNAL-TRANSFER" in this.terms) {
        tabs.push({
          tabName: "Direct Journal Transfer",
          term: "DIRECT-JOURNAL-TRANSFER",
        });
      }

      if ("VIDEO-GUIDES" in this.terms) {
        tabs.push({ tabName: "Video Guides", term: "VIDEO-GUIDES" });
      }

      if ("SUBMIT-TO-JOURNAL" in this.terms) {
        tabs.push({ tabName: "Submit To Journal", term: "SUBMIT-TO-JOURNAL" });
      }

      return tabs;
    },
    pageMapping() {
      return this.tabs.map((tab) => tab.term.toLowerCase());
    },
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    bannerGutter() {
      return this.layout.staticBannerGuttering;
    },
    centeredTabs() {
      return this.layout.infoPageTabsCentered;
    },
  },
  watchQuery: ["show"],
};
</script>

<style>
.SubmissionInformation .lowercase {
  text-transform: lowercase;
}
</style>
